import {
    createAnalogousPalette,
    createComplementaryPalette,
    createPrimaryPalette,
    createTriadicPalette,
    toRgbColorOrNull,
  } from '@yosulramp/material-color-palette-js';

const content_blocks = require('./contents');

let dt_index = null;
let dt_users = null;
let dt_groups = null;
let dt_users_to_add = null;
let microsite_id = null;
let custom_color_schema = null;
let custom_primary_color = null;
let custom_secondary_color = null;

export function index(){

    dt_index = $('#microsites_table').DataTable({
        ajax: {
            url: $('#microsites_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_microsites_actions },
            { data: 'name', orderable: true, searchable: true },
            { data: 'url', orderable: true, searchable: true },
            { data: 'template', orderable: true, searchable: true },
        ],
        order: [[3, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_microsites"]').click(batch_delete_microsite);
    });

    // dt_index.on('draw', function(e, settings){
    //     $(settings.nTableWrapper).find('.update_active').click(update_active);
    // });

}

function render_microsites_actions(data, type, row){

    const url_info = ($("#microsites_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

export function show(params){

    init_users();
    init_groups();

    microsite_id = params.microsite_id;
    custom_color_schema = params.custom_color_schema;

    if (custom_color_schema != null) {
        let primary_palette = custom_color_schema['colors']['primary'];
        let secondary_palette = custom_color_schema['colors']['secondary'];

        custom_primary_color = primary_palette[custom_color_schema['primary']['shade']];
        custom_secondary_color = secondary_palette[custom_color_schema['secondary']['shade']];
    }
    // window.app.microsites.variables.index(params);
    window.app.microsites.tokens.index(params);

    $('#edit_microsite select[name="language"]').change(function(){
        $('#edit_microsite input[name="languages[]"][value="' + $(this).val() + '"]').prop('checked', true);
    });

    $('#edit_microsite input[name="languages[]"]').change(function(){
        if(
            !$(this).prop('checked')
            && $(this).val() == $('#edit_microsite select[name="language"]').val()
        ){
            $(this).prop('checked', true);
        }
    });

    $('#sync_microsite').on('click', function(){
        let url = window._routes['microsites.sync'].replace('{microsite}', microsite_id);
        let button = $(this);

        window.forms.post(url, [], true, true)
            .then((response) => {
                if (response.status == 200) {
                    switch (response.data.message_level) {
                        case 'error':
                            window.messages.error(response.data.message);
                            break;
                    
                        default:
                            window.messages.info(response.data.message);
                            if (button.hasClass('disabled')) {
                                button.removeClass('disabled');
                            } else {
                                button.addClass('disabled');
                            }
                            break;
                    }
                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
            });
    });

    $('#edit_microsite').on("submit", function(e) {

        e.preventDefault();
        let url = $(this)[0].action;
        let form_data = new FormData($(this)[0]);

        window.forms.post(url, form_data, true, true)
            .then((response) => {
                if (response.data != null) {
                    switch (response.data.message_level) {
                        case 'error':
                            window.messages.error(response.data.message);
                            break;
                    
                        default:
                            window.messages.info(response.data.message);
                            break;
                    }
                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
                location.reload();
            });
            
    });

    $('#edit_template').on("submit", function(e) {

        e.preventDefault();
        let url = $(this)[0].action;
        let form = $(this);
        let form_data = new FormData($(this)[0]);

        $('.tinymce-textarea').each(function(){
            let textarea = $(this).find('textarea');
            // $(this).find('textarea').tinymce().save();
            form_data.set(textarea.attr('name'), form.find('[name="'+textarea.attr('name')+'"]').val());
        });
        
        form_data.set('contact_data', $(this).find('[name="contact_data"]').val());

        form_data.set('aviso_legal', $(this).find('[name="aviso_legal"]').val());
        form_data.set('politica_privacidad', $(this).find('[name="politica_privacidad"]').val());
        form_data.set('politica_cookies', $(this).find('[name="politica_cookies"]').val());

        window.forms.post(url, form_data, true, true)
            .then((response) => {
                if (response.data != null) {
                    switch (response.data.message_level) {
                        case 'error':
                            window.messages.error(response.data.message);
                            break;
                    
                        default:
                            window.messages.info(response.data.message);
                            break;
                    }
                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
            });
    });

    $('#edit_template').find('button.delete_media').on('click', function() {
        delete_variable_media($(this).attr('data-variable-id'), $(this).attr('data-media-id'));
    });

    let color_scheme_selector = $('#edit_color_palette_microsite select[name="color_scheme"]');
    color_scheme_selector.change(function(){
        show_hide_custom_colors($(this).val());
    });

    show_hide_custom_colors(color_scheme_selector.val());

    function show_hide_custom_colors(color_scheme){
        if(color_scheme == 'custom'){
            let primary_color_container = $('#edit_color_palette_microsite').find('[name="primary_color"]').closest('.x-form-input');
            let secondary_color_container = $('#edit_color_palette_microsite').find('[name="secondary_color"]').closest('.x-form-input');

            primary_color_container.removeClass('d-none')
            secondary_color_container.removeClass('d-none')

            if (custom_color_schema != null) {
                
                let primary_palette_string = custom_color_schema['colors']['primary'].join().replaceAll('#', '');
                let primary_palette_exploded = primary_palette_string.split(','); 
    
                print_palette(primary_color_container, primary_palette_exploded, custom_primary_color.replace('#', ''), 'primary');
    
                let secondary_palette_string = custom_color_schema['colors']['secondary'].join().replaceAll('#', '');
                let secondary_palette_exploded = secondary_palette_string.split(','); 
                print_palette(secondary_color_container, secondary_palette_exploded, custom_secondary_color.replace('#', ''), 'secondary');
            }

            $('#edit_color_palette_microsite .event_input_color').each(function(){
                $(this).removeClass('d-none');
            });
        } else {
            let primary_color_container = $('#edit_color_palette_microsite').find('[name="primary_color"]').closest('.x-form-input');
            let secondary_color_container = $('#edit_color_palette_microsite').find('[name="secondary_color"]').closest('.x-form-input');

            primary_color_container.addClass('d-none');
            secondary_color_container.addClass('d-none');

            primary_color_container.next('.palette_container').remove();
            secondary_color_container.next('.palette_container').remove();

            $('#edit_color_palette_microsite .event_input_color').each(function(){
                $(this).addClass('d-none');
            });
        }
    }

    $('#edit_color_palette_microsite input[name="primary_color"]').change(function(){
        custom_primary_color = $(this).val();
        let input_container = $(this).closest('.x-form-input');
        let replaced_color = custom_primary_color.replace('#', '');

        // Creamos la paleta del color primario
        const customPrimaryPalette = createPrimaryPalette(replaced_color);
        const primary_palette_colors = customPrimaryPalette?.map(rgbColor => rgbColor.rgbHex);
        $('#edit_color_palette_microsite input[name="primary_palette"]').val(primary_palette_colors.map(i => '#' + i));

        // Printamos los cuadros con los colores de la paleta
        print_palette(input_container, primary_palette_colors, replaced_color, 'primary');

        // Generamos los colores para los eventos del calendario
        let calendar_palette_colors = [];

        

        let triadicColor = toRgbColorOrNull(replaced_color)?.toHslColor().triadicColor;
        triadicColor?.map(hslColor => calendar_palette_colors.push(hslColor.toRgbColor().rgbHex));

        let complementaryColor = toRgbColorOrNull(replaced_color)?.toHslColor().complementaryColor;
        calendar_palette_colors.push(complementaryColor.toRgbColor().rgbHex);

        let analogousColor = toRgbColorOrNull(replaced_color)?.toHslColor().analogousColor;
        analogousColor?.map(hslColor => calendar_palette_colors.push(hslColor.toRgbColor().rgbHex));
        
        calendar_palette_colors = calendar_palette_colors.map(i => '#' + i);
        let event_inputs_colors = $('#edit_color_palette_microsite .event_input_color');

        for (let index = 0; index < calendar_palette_colors.length; index++) {
            $(event_inputs_colors[index]).find('input[type="color"]').val(calendar_palette_colors[index]);
        }
    });

    $('#edit_color_palette_microsite input[name="secondary_color"]').change(function(){
        custom_secondary_color = $(this).val();
        let input_container = $(this).closest('.x-form-input');
        let replaced_color = custom_secondary_color.replace('#', '');
        const customPrimaryPalette = createPrimaryPalette(replaced_color);
        const palette_colors = customPrimaryPalette?.map(rgbColor => rgbColor.rgbHex);
        $('#edit_color_palette_microsite input[name="secondary_palette"]').val(palette_colors.map(i => '#' + i));
        print_palette(input_container, palette_colors, replaced_color, 'secondary');
    });

    function init_custom_colors(palette_container, palette_colors){
        let div = palette_container.prev('.x-form-input');

        palette_container.find('.custom_color').each(function(){
            $(this).on('click', function(){
                if (palette_container.attr('palette_type') == 'secondary') {
                    custom_secondary_color = $(this).attr('color');
                    print_palette(palette_container.prev('.x-form-input'), palette_colors, custom_secondary_color.replace('#', ''), 'secondary');
                    div.find('input[type="color"]').val(custom_secondary_color);
                } else {
                    custom_primary_color = $(this).attr('color');
                    print_palette(palette_container.prev('.x-form-input'), palette_colors, custom_primary_color.replace('#', ''), 'primary');
                    div.find('input[type="color"]').val(custom_primary_color);
                }
            })
        });
    }

    function print_palette(div, palette_colors, color, type = 'primary'){
        let color_rounded = encontrarColorMasCercano(color.toUpperCase(), palette_colors);
        let newDiv = `<div class="palette_container d-flex" palette_type="${type}">`;
        palette_colors.forEach(element => {
            newDiv += `<div class="custom_color mb-3" color="#${element}" style="background-color: #${element}; width: 64px; height: 64px;${element == color_rounded ? 'border-radius: 50%;' : ''}"></div>`;
        });
        newDiv += '</div>';
        $(div).next(".palette_container").remove();
        div.after(newDiv);
        
        let palette_container = div.next('.palette_container');
        init_custom_colors(palette_container, palette_colors);
    }

    function encontrarColorMasCercano(colorActual, arrayColores) {
        // Convierte el color actual de hexadecimal a LAB
        function hexToLab(hex) {
            // Elimina el # si está presente
            hex = hex.replace(/^#/, '');

            // Convierte el color a RGB
            const bigint = parseInt(hex, 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;

            // Convierte RGB a LAB
            const x = (r / 255.0) * 100.0;
            const y = (g / 255.0) * 100.0;
            const z = (b / 255.0) * 100.0;

            const pivot = 0.04045;
            const divisor = 12.92;

            const transform = (value) => {
                const factor = 100.0 / 255.0;
                const normalized = value / 255.0;

                return normalized <= pivot
                    ? (normalized / divisor) * factor
                    : Math.pow((normalized + 0.055) / 1.055, 2.4) * factor;
            };

            const rLinear = transform(r);
            const gLinear = transform(g);
            const bLinear = transform(b);

            const xLinear = rLinear * 0.4124564 + gLinear * 0.3575761 + bLinear * 0.1804375;
            const yLinear = rLinear * 0.2126729 + gLinear * 0.7151522 + bLinear * 0.0721750;
            const zLinear = rLinear * 0.0193339 + gLinear * 0.1191920 + bLinear * 0.9503041;

            const pivotLab = 0.008856;
            const factorLab = 903.3;

            const transformLab = (value) =>
                value > pivotLab
                    ? Math.pow(value, 1.0 / 3.0)
                    : value * factorLab + 16.0 / 116.0;

            const xLab = transformLab(xLinear / 95.047);
            const yLab = transformLab(yLinear / 100.000);
            const zLab = transformLab(zLinear / 108.883);

            return { L: 116.0 * yLab - 16.0, a: xLab - yLab, b: yLab - zLab };
        }

        // Calcula la diferencia entre dos colores en el espacio LAB
        function calcularDiferenciaLab(color1, color2) {
            const deltaL = color1.L - color2.L;
            const deltaA = color1.a - color2.a;
            const deltaB = color1.b - color2.b;

            return Math.sqrt(deltaL * deltaL + deltaA * deltaA + deltaB * deltaB);
        }

        // Convierte el color actual a LAB
        const colorActualLab = hexToLab(colorActual);

        // Inicializa variables para el color más cercano y la diferencia mínima
        let colorMasCercano = arrayColores[0];
        let diferenciaMinima = calcularDiferenciaLab(colorActualLab, hexToLab(colorMasCercano));

        // Itera sobre el array de colores para encontrar el más cercano
        for (let i = 1; i < arrayColores.length; i++) {
            const color = arrayColores[i];
            const diferencia = calcularDiferenciaLab(colorActualLab, hexToLab(color));

            // Actualiza el color más cercano si la diferencia es menor
            if (diferencia < diferenciaMinima) {
                diferenciaMinima = diferencia;
                colorMasCercano = color;
            }
        }

        return colorMasCercano;
    }

    // $('#edit_template').find('select[name="color_scheme"]').on('change', function() {
    //     let palette = $(this).val();
    //     let colors = color_palettes[palette];
    //     // init_color_footer_style(colors.colors);
    // });

    // $('#edit_template').find('select').each(function() {
    //     // Create a DOM Option and pre-select by default
    //     var newOption = new Option("Ninguno", 0, true, false);
    //     // Append it to the select
    //     $(this).append(newOption).trigger('change');
    // });

    $('#edit_template').find('.x-form-input.tinymce-textarea').each(function(){
        init_tiny($(this).find('textarea'));
    });

    $('#edit_template .footer_type select').each(function(){
        show_footer_widgets($(this).attr('name'), $(this).val());
    });

    $('#edit_template .footer_type select').change(function(){
        show_footer_widgets($(this).attr('name'), $(this).val());
    });

    $('#edit_template input[name="show_content_author"]').on('click', function() {
        $(this).val($(this).prop('checked') ? 1 : 0);
    });
}

function init_users() {
    // datatable microsite_users
        
    dt_users = $('#microsite_users_table').DataTable({
        ajax: {
            url: $('#microsite_users_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_microsites_user_actions },
            { data: 'username', orderable: true, searchable: false },
            { data: 'usuario', orderable: false, searchable: false },
            { data: 'roles', orderable: false, searchable: true },
        ],
        order: [[1, 'asc']],
    });
}

function render_microsites_user_actions(data, type, row) {
    const url_info = ($("#microsite_users_table").attr('url_info') ?? '').replace('#', row.owner_id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

function batch_delete_microsite(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.batch_delete'];
    
    let microsites_id = [];
    $.each(rows_selected, function(index, rowId){
        microsites_id.push(rowId);
    });
    
    if(microsites_id.length == 0){

        window.messages.error(__('No has seleccionado ningún microsite'));

    } else {

        const title = __('Eliminar microsites');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un microsite.|[2,*] Estás a punto de eliminar :count microsites.', microsites_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    for(let microsite_id of microsites_id){
                        formData.append('microsites_id[]', microsite_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}

export function filter_users(data){

    return {
        results: $.map(data.results, function(obj, index) {
            let user = obj.username + '<small class="d-block font-weight-light">' + obj.name + ' ' + (obj.surname != null ? obj.surname : '') + "</small>";
            return { 
                id: obj.id,
                text: obj.username,
                result: user
            };
        })
    };
}

function init_groups() {
    // datatable microsite_groups
        
    dt_groups = $('#microsite_groups_table').DataTable({
        ajax: {
            url: $('#microsite_groups_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_microsites_group_actions },
            { data: 'name', orderable: true, searchable: true },
            { data: 'roles', orderable: false, searchable: true },
        ],
        order: [[1, 'asc']],
    });
}

function render_microsites_group_actions(data, type, row) {
    const url_info = ($("#microsite_groups_table").attr('url_info') ?? '').replace('#', row.owner_id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

export function filter_groups(data){

    return {
        results: $.map(data.results, function(obj, index) {
            // let user = obj.username + '<small class="d-block font-weight-light">' + obj.name + ' ' + (obj.surname != null ? obj.surname : '') + "</small>";
            let group = obj.name;
            return { 
                id: obj.id,
                text: obj.name,
                result: group
            };
        })
    };
}

export function filter_home_content(data){

    data.results.unshift({
        id: 0,
        title: "Ninguno",
        slug: ""
    });

    return {
        results: $.map(data.results, function(obj, index) {
            return { 
                id: obj.id,
                text: obj.title,
                result: obj.title + '<small class="d-block font-weight-light">' + obj.slug + "</small>"
            };
        })
    };
}

function delete_variable_media(variable_id, media_id) {
    let url = window._routes['microsites.variables.media.delete'].replace('{microsite}', microsite_id).replace('{variable}', variable_id);

    let form_data = new FormData();
    form_data.append('media_id', media_id);
    window.forms.post(url, form_data, true, true)
        .then((response) => {
            if (response.data != null) {
                let form_input = $('button[data-variable-id="'+variable_id+'"]').closest('.row');
                let image = form_input.find('input[type="file"]');
                let label = image.next('label');
                label.text('');
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}

function init_tiny(textarea){

    const url = window._routes['microsites.variables.post_image_tiny'].replace('{microsite}', microsite_id).replace('{variable}', textarea.attr("model_id"));

    let options = {
        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist image link | removeformat code',
        file_picker_types: 'image',
        file_picker_callback: function (cb, value, meta) {

            var input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
        
            input.onchange = function(){
                
                var file = this.files[0];
                var reader = new FileReader();

                reader.onload = function(){

                    var id = 'blobid' + (new Date()).getTime();
                    var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                    var base64 = reader.result.split(',')[1];
                    var blobInfo = blobCache.create(id, file, base64);
                    blobCache.add(blobInfo);
        
                    /* call the callback and populate the Title field with the file name */
                    cb(blobInfo.blobUri(), { title: file.name });

                };

                reader.readAsDataURL(file);

            };
        
            input.click();
            
        },
        images_upload_handler: function(blobInfo, success, failure){

            let form_data = {
                filename: blobInfo.blob().name,
                type: blobInfo.blob().type,
                base64: blobInfo.base64(),
            };

            window.forms.post(url, form_data, true, true)
                .then((response) => {
                    success(response.data.location);
                })
                .catch((error) => {
                    console.log('ERROR', error);
                    failure(window.__('Error subiendo imagen tinymce'));
                })
                .finally(() => {
                    window.blockui.release();
                });

        },
    };

    window.forms.init_tinymce(textarea, options);

}

function show_footer_widgets(variable, value) {
    switch (value) {
        case 'html':
            $('input[name="'+variable+'_title"]').closest('.x-form-input').removeClass('d-none');
            $('textarea[name="'+variable+'_html"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="'+variable+'_menu"]').closest('.x-form-input').addClass('d-none');
            $('.row.'+variable+'.rrss').addClass('d-none');
            break;
        case 'menu':
            $('input[name="'+variable+'_title"]').closest('.x-form-input').removeClass('d-none');
            $('textarea[name="'+variable+'_html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="'+variable+'_menu"]').closest('.x-form-input').removeClass('d-none');
            $('.row.'+variable+'.rrss').addClass('d-none');
            break;

        case 'rrss':
            $('input[name="'+variable+'_title"]').closest('.x-form-input').removeClass('d-none');
            $('textarea[name="'+variable+'_html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="'+variable+'_menu"]').closest('.x-form-input').addClass('d-none');
            $('.row.'+variable+'.rrss').removeClass('d-none');
            break;
    
        default:
            $('input[name="'+variable+'_title"]').closest('.x-form-input').addClass('d-none');
            $('textarea[name="'+variable+'_html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="'+variable+'_menu"]').closest('.x-form-input').addClass('d-none');
            $('.row.'+variable+'.rrss').addClass('d-none');
            
            break;
    }
}

// function init_color_footer_style(colors) {

//     let select = $('#edit_template').find('select[name="footer_style"]');
    
//     select.find('option').each(function() {
//         $(this).remove();
//     });

//     for (const color_palette in colors) {
//         for(const color in colors[color_palette]) {

//             var data = {
//                 id: colors[color_palette][color],
//                 text: `${color_palette}  ${colors[color_palette][color]}`
//             };
            
//             var newOption = new Option(data.text, data.id, false, false);
//             select.append(newOption).trigger('change');
//         }
//     }
// }